export default class Menu {
  constructor() {
    this.this = '#main-menu'
    this.$this = $(this.this)
    this.$mainMenu = $('#main-menu').find('.main-menu-ul')
    this.elementItem = '.hamburger-menu, html, #main-menu, #header'
    this.$header = $('#header, #main-menu-mobile')
    this.$hamburgerMenu = $('.hamburger-menu')
    // Exclude has-sub > a so clicking the link text navigates normally.
    // .sub-arrow inside those links is handled separately in clickArrowOpenDropdownMenuLevel1.
    this.li = this.$this.find('.main-menu-ul >li:not(.has-sub)>a, .main-menu-ul >li>button')
    this.liLevel1 = this.$this.find('.main-menu-ul >li')
    this.liLevel2 = this.$this.find('.main-menu-ul .main-menu-dropdown li>a, .main-menu-ul .main-menu-dropdown li>button')
    this.isOpenMenu = 'is-open-menu'
    this.isOpenMenuChild = 'open-menu-child'
    this.isOpenChild = 'is-open-child'
    this.$linksInMenu = $('.header a:not(.skip-link), .header button')
    this.$firstLinkInMenu = this.$linksInMenu.first()
    this.$lastLinkInMenu = this.$linksInMenu.last()
    this.$skipLink = $('.header a.skip-link')
    this.ariaExpanded = 'aria-expanded'
    this.classHover = 'hovering'
    // One "restore default state" callback per mega menu, registered by
    // initMegaMenuAccordions(). Its internals are closure-local, so this array is
    // the only way the Level-1 back button / menu close can clear Level-3 state.
    this.megaResets = []
  }

  init() {
    if (this.$this.length) {
      this.openMainMenu()
      this.clickArrowOpenDropdownMenuLevel1()
      this.clickLiOpenDropdownMenuLevel1()
      this.clickArrowOpenDropdownMenuLevel2()
      this.clickOutSite()
      this.clickLiOpenDropdownMenuLevel2()
      this.toggleTabIndexSkipLink()
      this.hoverOpenMenu()
      this.clickMobileBack()
      this.initMegaMenuAccordions()
    }
  }

  initMegaMenuAccordions() {
    document.querySelectorAll('.mega-col--accordion').forEach((accordionCol) => {
      const inner = accordionCol.closest('.mega-menu__inner')
      if (!inner) return

      const level3Wrapper = inner.querySelector('.mega-col--level3-wrapper')

      // Handle for the deferred content-hide scheduled by closeLevel3(). Cancelled
      // as soon as anything re-activates a panel — otherwise a quick Back→tap lets
      // the stale timer hide the panel that was just opened.
      let cancelPendingHide = null

      const resetAll = () => {
        if (cancelPendingHide) cancelPendingHide()
        accordionCol.querySelectorAll('.secondary-nav-item').forEach((b) => {
          b.classList.remove('is-active')
          b.setAttribute('aria-expanded', 'false')
        })
        if (level3Wrapper) {
          level3Wrapper.querySelectorAll('.mega-subpanel').forEach((p) => {
            p.classList.remove('is-active')
            p.setAttribute('hidden', '')
          })
          level3Wrapper.classList.remove('is-active')
        }
        inner.querySelectorAll('.mega-card-image__panel-img').forEach((img) => {
          img.classList.remove('is-visible')
        })
        // Default state: show the parent's own image if it has one, otherwise hide
        // the whole card. Never falls back to a child's image. This is also the
        // resting state for any Lv1 that has no image of its own — activatePanel()
        // leaves it exactly as set here.
        const imageCard = inner.querySelector('.mega-col--image-card')
        const defaultImg = inner.querySelector('.mega-card-image__default-img')
        if (imageCard) imageCard.classList.toggle('is-hidden', !defaultImg)
      }

      // Activate one accordion item: show its Level-3 panel + image card.
      // Shared by hover and click.
      const activatePanel = (btn) => {
        const targetId = btn.getAttribute('data-target')
        if (!targetId) return

        // Deactivate all, then activate this button's panel + image
        resetAll()

        btn.classList.add('is-active')
        btn.setAttribute('aria-expanded', 'true')

        const panel = document.getElementById(targetId)
        if (panel) {
          panel.classList.add('is-active')
          panel.removeAttribute('hidden')
        }
        if (level3Wrapper) level3Wrapper.classList.add('is-active')

        const targetImg = inner.querySelector(`.mega-card-image__panel-img[data-for="${targetId}"]`)
        const imageCard = inner.querySelector('.mega-col--image-card')
        if (targetImg) {
          targetImg.classList.add('is-visible')
          if (imageCard) imageCard.classList.remove('is-hidden')
        }
        // No `else`: a Lv1 without its own image falls back to the parent's default
        // image, which resetAll() has already left in place (and which also decided
        // whether the card shows at all — parent unset ⇒ still hidden). Deliberately
        // NOT hiding here, because hovering between two imageless Lv1 items would
        // then toggle `is-hidden` on the 318px column and reflow the Level-3 text.
        // As written, that path touches no DOM at all, so the image cannot flicker.
      }

      // hoverIntent: only SWITCH the active panel when the cursor dwells on a new
      // item. This lets the user move diagonally from the active item toward its
      // Level-3 links (which pass over the items below it) without those items
      // hijacking the panel. The first open — when nothing is active yet — is
      // instant since there's no diagonal to protect.
      let switchTimer = null
      const SWITCH_DELAY = 250

      // True while the active item is only the DEFAULT pick (set by
      // setDefaultActive), not a real user choice. The dwell delay exists to
      // protect a diagonal cursor path toward Level-3 links the user asked for —
      // there is nothing to protect yet when the panel was opened for them, so
      // the first real hover still switches instantly.
      let activeIsDefault = false

      const clearSwitch = () => {
        if (switchTimer) {
          clearTimeout(switchTimer)
          switchTimer = null
        }
      }

      // Default state: on desktop the FIRST item is pre-activated, so the Level-3
      // column and its image are never empty — at page load and again whenever the
      // cursor leaves the mega menu. On mobile we keep the Level-2 list visible —
      // the Level-3 wrapper slides in only on tap — so only highlight instead.
      // `.is-current` is rendered server-side on the Level-2 item that owns the
      // page being viewed (gg_menu_current_class in PHP). Prefer it over the
      // first item so opening the mega menu lands on the section you are in.
      const firstPanelItem =
        accordionCol.querySelector('button.secondary-nav-item.is-current') ||
        accordionCol.querySelector('button.secondary-nav-item') ||
        accordionCol.querySelector('.secondary-nav-item')
      const setDefaultActive = () => {
        clearSwitch()
        if (!firstPanelItem) {
          resetAll()
          return
        }
        if (window.innerWidth >= 1200) {
          // Desktop: open the first item's panel + its image card.
          activatePanel(firstPanelItem)
          activeIsDefault = true
        } else {
          // Below 1200: pre-activate NOTHING. At this breakpoint `is-active` on
          // the Level-3 wrapper means "slid in over the Level-2 list", and a
          // highlighted item with no open panel reads as a wrong state — so the
          // list starts clean and Level-3 opens only on tap.
          resetAll()
        }
      }

      // Back (mobile only, Level-3 → Level-2). Deliberately TWO-PHASE:
      //
      //   now   — slide the wrapper out and drop the Level-2 pill. The pill lives
      //           in the sibling `.mega-col--accordion` column, so no amount of
      //           parentElement/closest from the button reaches it.
      //   later — hide the sub-panel content, once the 0.3s slide-out has finished.
      //           `.mega-subpanel` loses `is-active` → `display:none`, so clearing
      //           it now would slide an EMPTY panel off screen. Re-adding `hidden`
      //           is also what stops the off-screen Level-3 links from staying
      //           Tab-focusable.
      const closeLevel3 = () => {
        if (!level3Wrapper) return

        level3Wrapper.classList.remove('is-active')
        accordionCol.querySelectorAll('.secondary-nav-item').forEach((b) => {
          b.classList.remove('is-active')
          b.setAttribute('aria-expanded', 'false')
        })
        activeIsDefault = false

        if (cancelPendingHide) cancelPendingHide()

        const hideContent = () => {
          level3Wrapper.querySelectorAll('.mega-subpanel').forEach((p) => {
            p.classList.remove('is-active')
            p.setAttribute('hidden', '')
          })
          inner.querySelectorAll('.mega-card-image__panel-img').forEach((img) => {
            img.classList.remove('is-visible')
          })
        }

        let fallback = null
        let onEnd = null
        const cleanup = () => {
          if (onEnd) level3Wrapper.removeEventListener('transitionend', onEnd)
          if (fallback) clearTimeout(fallback)
          cancelPendingHide = null
          hideContent()
        }
        onEnd = (e) => {
          if (e.target !== level3Wrapper || e.propertyName !== 'transform') return
          cleanup()
        }

        level3Wrapper.addEventListener('transitionend', onEnd)
        // transitionend never fires when the transition is cancelled or the element
        // was never actually animated — the timeout guarantees the cleanup runs.
        fallback = setTimeout(cleanup, 400)

        cancelPendingHide = () => {
          if (onEnd) level3Wrapper.removeEventListener('transitionend', onEnd)
          if (fallback) clearTimeout(fallback)
          cancelPendingHide = null
        }
      }

      if (level3Wrapper) {
        level3Wrapper.querySelectorAll('.mega-level3-back').forEach((backBtn) => {
          backBtn.addEventListener('click', closeLevel3)
        })
      }

      accordionCol.querySelectorAll('.secondary-nav-item').forEach((btn) => {
        btn.addEventListener('mouseenter', () => {
          if (window.innerWidth < 1200) return
          if (btn.classList.contains('is-active')) return

          clearSwitch()
          const hasActive = accordionCol.querySelector('.secondary-nav-item.is-active')
          if (!hasActive || activeIsDefault) {
            // Nothing chosen yet (or only the default) — no diagonal to protect.
            activeIsDefault = false
            activatePanel(btn)
          } else {
            switchTimer = setTimeout(() => {
              switchTimer = null
              activeIsDefault = false
              activatePanel(btn)
            }, SWITCH_DELAY)
          }
        })

        // Leaving the item before the dwell completes cancels the pending switch.
        btn.addEventListener('mouseleave', clearSwitch)

        btn.addEventListener('click', () => {
          // Only <button> toggles open a sub-panel. Items without sub-items are
          // rendered as real <a> links — let the browser navigate instead of
          // sliding into an empty Level-3 panel (which looked like a blank page).
          if (btn.tagName === 'A') return

          clearSwitch()
          activeIsDefault = false
          activatePanel(btn)
        })
      })

      // Initial state: first panel active on desktop, list-first on mobile.
      setDefaultActive()

      // Re-apply the default when the viewport CROSSES 1200px. The desktop
      // default leaves `is-active` on the Level-3 wrapper, which below 1200 is
      // styled as "slid in over the Level-2 list" — so a desktop→mobile resize
      // would otherwise strand the panel open on top of the menu.
      let wasDesktop = window.innerWidth >= 1200
      window.addEventListener('resize', () => {
        const isDesktop = window.innerWidth >= 1200
        if (isDesktop === wasDesktop) return
        wasDesktop = isDesktop
        setDefaultActive()
      })

      // Restore the default panel when the cursor leaves the whole mega inner
      // (so reopening shows content again instead of an empty right column).
      inner.addEventListener('mouseleave', () => {
        if (window.innerWidth < 1200) return
        setDefaultActive()
      })

      // Let the outside world (Level-1 back, menu close) restore this mega menu.
      // setDefaultActive — not resetAll — because it is breakpoint-aware: desktop
      // re-selects item 1, mobile clears everything.
      this.megaResets.push(setDefaultActive)
    })
  }

  /** Restore every mega menu to its default state (see initMegaMenuAccordions). */
  resetMegaMenus() {
    this.megaResets.forEach((reset) => reset())
  }

  clickMobileBack() {
    this.$this.on('click', '.mobile-menu-back', (e) => {
      e.stopPropagation()
      const $li = $(e.currentTarget).closest('.menu-item')
      $li.removeClass(this.isOpenChild)
      $li.find('> a, > button').attr(this.ariaExpanded, false)
      // Closing the Level-1 dropdown must also clear the mega menu's Level-3
      // state, or reopening lands on Level-3 slid in over the Level-2 list.
      this.resetMegaMenus()
    })
  }

  /* micro function */
  microOpenCloseLevel1(currentElement, openClass, isLiLv1 = false) {
    const ele = currentElement.currentTarget
    const eleParent = $(ele).parent()
    if ($(window).width() < 1200) {
      if (eleParent.find('ul, .main-menu-dropdown').length && !eleParent.hasClass(openClass)) {
        this.liLevel1.removeClass(openClass)
        this.liLevel1.find('> a, > button').each((_i, el) => {
          if ($(el).attr(this.ariaExpanded)) {
            $(el).attr(this.ariaExpanded, false)
          }
        })
        eleParent.addClass(openClass)
        $(ele).attr(this.ariaExpanded, true)
        if (isLiLv1) {
          return false
        }
      } else {
        eleParent.removeClass(openClass)
        $(ele).attr(this.ariaExpanded, false)
      }
    }
    return true
  }
  /* end micro */

  openMainMenu() {
    this.$header.on('click', '.hamburger-menu', (e) => {
      const ele = e.currentTarget

      if ($(ele).hasClass(this.isOpenMenu)) {
        $(this.elementItem).removeClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Open menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, false)
        this.$skipLink.removeAttr('tabindex')
        this.resetMegaMenus() // don't reopen the menu on a stale Level-3 panel
      } else {
        $(this.elementItem).addClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Close menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, true)
        this.bindEventFocusOnMenu()
      }
    })
  }

  toggleTabIndexSkipLink() {
    $(window).on('resize', () => {
      if ($(window).outerWidth() < 1200) {
        this.$skipLink.removeAttr('tabindex')
      }
    })
  }

  bindEventFocusOnMenu() {
    this.$skipLink.attr('tabindex', -1)
    this.$firstLinkInMenu.get(0).addEventListener('keydown', this.shiftTabFocusToLast.bind(this))
    this.$lastLinkInMenu.get(0).addEventListener('keydown', this.tabFocusToFirst.bind(this))
  }

  tabFocusToFirst(e) {
    if (e.which === 9 && $(window).outerWidth() < 1200 && !e.shiftKey) {
      e.preventDefault()
      this.$firstLinkInMenu.focus()
    }
  }

  shiftTabFocusToLast(e) {
    if (e.which === 9 && $(window).outerWidth() < 1200 && e.shiftKey) {
      e.preventDefault()
      this.$lastLinkInMenu.focus()
    }
  }

  clickArrowOpenDropdownMenuLevel1() {
    this.liLevel1.on('click', '.arrows-lv1', (e) => {
      this.microOpenCloseLevel1(e, this.isOpenChild)
    })

    // Click on .sub-arrow inside an <a> link (has-sub + has URL):
    // prevent navigation, stop bubbling, then open dropdown using the <a> as context.
    this.$this.find('.main-menu-ul li.has-sub > a.menu-item__link .sub-arrow').on('click.subArrow', (e) => {
      if ($(window).width() >= 1200) return
      e.preventDefault()
      e.stopPropagation()
      const $a = $(e.currentTarget).closest('a.menu-item__link')
      this.microOpenCloseLevel1({ currentTarget: $a[0] }, this.isOpenChild)
    })
  }

  clickLiOpenDropdownMenuLevel1() {
    this.li.on('click', (e) => this.microOpenCloseLevel1(e, this.isOpenChild, true))
  }

  clickArrowOpenDropdownMenuLevel2() {
    this.$this.find('.main-menu-ul').on('click', '.arrows-lv2', (e) => {
      const ele = e.currentTarget
      const eleParent = $(ele).parent()
      if ($(window).width() < 1200) {
        if (eleParent.find('.menu-child').length && !eleParent.hasClass(this.isOpenMenuChild)) {
          eleParent.addClass(this.isOpenMenuChild)
        } else {
          eleParent.removeClass(this.isOpenMenuChild)
        }
      }
    })
  }

  clickOutSite() {
    $(document).on('click', (event) => {
      if (!$(event.target).closest('#header.is-open-menu').length) {
        // This fires on EVERY document click, so only reset when the mobile menu
        // was genuinely open — an unconditional reset would wipe the user's
        // desktop hover selection on every click anywhere on the page.
        const wasOpen = $('#header').hasClass(this.isOpenMenu)
        $(this.elementItem).removeClass(this.isOpenMenu)
        if (wasOpen) this.resetMegaMenus()
      }
    })
  }

  clickLiOpenDropdownMenuLevel2() {
    this.liLevel2.on('click', (e) => {
      const ele = e.currentTarget
      const eleParent = $(ele).parent()
      if ($(window).width() < 1200 && eleParent.find('ul').length && !eleParent.hasClass(this.isOpenMenuChild)) {
        this.li.removeClass(this.isOpenMenuChild)
        eleParent.addClass(this.isOpenMenuChild)
        return false
      }
      return true
    })
  }

  closeAllSubmenu() {
    const $liHover = this.$this.find('.main-menu-ul>li.hovering')
    $liHover.removeClass('hovering')
    if ($liHover.hasClass('has-sub')) {
      $liHover.find('> a, > button').attr(this.ariaExpanded, false)
    }
  }

  /**
   * Desktop hover behavior for the main menu, with two UX safeguards:
   *
   * 1. hoverIntent-lite: open the dropdown only when the mouse slows down
   *    (velocity below OPEN_THRESHOLD_PX_PER_MS) or stalls past OPEN_MAX_WAIT_MS.
   *    Prevents accidental opens when the user is just sweeping across the bar.
   * 2. Close grace (CLOSE_GRACE_MS): single timer on mouseleave of the whole
   *    menu, cancelled if the user re-enters. Pairs with the invisible CSS
   *    bridge that covers the gap between trigger and dropdown.
   */
  hoverOpenMenu() {
    const classHoverHeader = 'pin-color'
    // Tuning knobs — adjust based on feel.
    const OPEN_THRESHOLD_PX_PER_MS = 0.35 // mouse must move slower than this to open
    const CLOSE_GRACE_MS = 150            // delay before closing after leaving the menu
    const OPEN_MAX_WAIT_MS = 150          // fallback: force open even if mouse stays fast

    let pendingOpenEl = null      // item queued for opening, awaiting slow-down
    let openRaf = null            // rAF handle for the open polling loop
    let closeTimer = null         // setTimeout handle for delayed close
    let openMegaMenuTimer = null  // setTimeout handle for deferred .open-mega-menu removal
    let lastX = 0
    let lastY = 0
    let lastT = 0
    let mouseVel = 0          // current mouse velocity in px/ms

    const isDesktop = () => $(window).outerWidth() >= 1200

    /**
     * Opens the dropdown for `ele`. Handles the special "mega → mega" switch
     * case by temporarily disabling transitions on both the outgoing and
     * incoming dropdowns — otherwise the parallel fade-out/fade-in creates a
     * window where total opacity drops below 1 and page content shows through.
     * Single ↔ mega switches keep their normal fade since only one dropdown is
     * involved.
     */
    const doOpen = (ele) => {
      const $currentHovering = this.$this.find(`.main-menu-ul > li.${this.classHover}`)
      const hadMegaOpen = $currentHovering.hasClass('has-sub')

      // Cancel any in-flight .open-mega-menu removal timer
      if (openMegaMenuTimer) {
        clearTimeout(openMegaMenuTimer)
        openMegaMenuTimer = null
      }

      // Instant switch only when BOTH the previous and the new item are mega
      // dropdowns. Otherwise let the regular CSS transition play.
      const isSwitching =
        $currentHovering.length > 0 &&
        !$currentHovering.is(ele) &&
        $currentHovering.hasClass('has-sub') &&
        $(ele).hasClass('has-sub')

      if (isSwitching) {
        $currentHovering.find('.main-menu-dropdown').addClass('no-transition')
        $(ele).find('.main-menu-dropdown').addClass('no-transition')
      }

      this.closeAllSubmenu()
      $(ele).addClass(this.classHover)
      if ($(ele).hasClass('has-sub')) {
        $(ele).find('> a, > button').attr(this.ariaExpanded, true)
      }
      this.$header.addClass(classHoverHeader)

      if ($(ele).hasClass('has-sub')) {
        // New item is a mega menu — add class immediately
        this.$header.addClass('open-mega-menu')
      } else if (hadMegaOpen) {
        // Switching from a mega item to a plain item — keep class until the old
        // dropdown finishes its close animation (0.2s delay + 0.2s fade = 400ms)
        openMegaMenuTimer = setTimeout(() => {
          this.$header.removeClass('open-mega-menu')
          openMegaMenuTimer = null
        }, 0)
      }

      if (isSwitching) {
        // Double rAF: wait for the browser to commit the no-transition style,
        // then remove the class so subsequent open/close animations work
        // normally. A single rAF can be batched with the class change and
        // skipped.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            $('.main-menu-dropdown.no-transition').removeClass('no-transition')
          })
        })
      }
    }

    const cancelPendingOpen = () => {
      pendingOpenEl = null
      if (openRaf) {
        cancelAnimationFrame(openRaf)
        openRaf = null
      }
    }

    // Poll mouse velocity each frame. Open as soon as the mouse slows down,
    // or after OPEN_MAX_WAIT_MS as a fallback if it stays fast (e.g. user
    // really did want this menu but never paused).
    const scheduleOpen = (ele) => {
      cancelPendingOpen()
      pendingOpenEl = ele
      const start = performance.now()
      const tick = () => {
        if (pendingOpenEl !== ele) return
        const elapsed = performance.now() - start
        if (mouseVel < OPEN_THRESHOLD_PX_PER_MS || elapsed > OPEN_MAX_WAIT_MS) {
          doOpen(ele)
          pendingOpenEl = null
          openRaf = null
        } else {
          openRaf = requestAnimationFrame(tick)
        }
      }
      openRaf = requestAnimationFrame(tick)
    }

    const doClose = () => {
      this.closeAllSubmenu()
      this.$header.removeClass(classHoverHeader)
      // Keep .open-mega-menu until the dropdown close animation finishes:
      // _menu.scss uses transition-delay: 0.2s + transition: 0.2s = 400ms total.
      openMegaMenuTimer = setTimeout(() => {
        this.$header.removeClass('open-mega-menu')
        openMegaMenuTimer = null
      }, 0)
    }

    // Track mouse velocity (px/ms) across the menu bar for hoverIntent.
    this.$mainMenu.on('mousemove', (e) => {
      const now = performance.now()
      if (lastT) {
        const dx = e.clientX - lastX
        const dy = e.clientY - lastY
        const dt = Math.max(1, now - lastT)
        mouseVel = Math.hypot(dx, dy) / dt
      }
      lastX = e.clientX
      lastY = e.clientY
      lastT = now
    })

    this.liLevel1.on('mouseenter', (e) => {
      if (!isDesktop()) return
      // Re-entering cancels a pending close (user came back during grace).
      if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
      }
      const ele = e.currentTarget
      if ($(ele).hasClass(this.classHover)) return
      scheduleOpen(ele)
    })

    // Leaving an item before it actually opened — cancel the pending open.
    this.liLevel1.on('mouseleave', (e) => {
      if (!isDesktop()) return
      if (pendingOpenEl === e.currentTarget) cancelPendingOpen()
    })

    // Leaving the whole menu bar — close after a short grace so quick
    // overshoots back into the menu don't trigger a close/open flicker.
    this.$mainMenu.on('mouseleave', () => {
      if (!isDesktop()) return
      cancelPendingOpen()
      if (closeTimer) clearTimeout(closeTimer)
      closeTimer = setTimeout(() => {
        doClose()
        closeTimer = null
      }, CLOSE_GRACE_MS)
    })

    $(window).on('keydown', (e) => {
      if (e.keyCode === 27 && isDesktop()) {
        cancelPendingOpen()
        if (closeTimer) {
          clearTimeout(closeTimer)
          closeTimer = null
        }
        doClose()
      }
    })

    // Close the mega menu on any scroll. The header auto-hides on scroll, so a
    // still-open dropdown would float detached from it. Only acts when a mega is
    // actually open (desktop), so it's a no-op on normal scrolling.
    $(window).on('scroll', () => {
      if (!isDesktop()) return
      if (!this.$this.find(`.main-menu-ul > li.${this.classHover}`).length) return
      cancelPendingOpen()
      if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
      }
      doClose()
    })
  }
}

new Menu().init()
